import { handleActions } from 'redux-actions';
import { setLanguage } from './actions';
import { LanguageDirections } from 'lib/languages';

const defaultState = {
  language: undefined,
  direction: undefined
};

export default handleActions({
  [setLanguage]: (state, { payload }) => ({
    language: payload,
    direction: LanguageDirections[payload]
  })
},
defaultState);



// WEBPACK FOOTER //
// ./src/store/language/reducer.js